import { useState, useEffect } from 'react';

export default function Contribution() {

    const [choice, setChoice] = useState(null);
    const [activity, setActivity] = useState([]);
    const email = localStorage.getItem("inviteEmail");

    const [song1, setSong1] = useState(null);
    const [song2, setSong2] = useState(null);

    const isLocal = window.location.hostname === "localhost";
    const API_URL = isLocal ? "http://localhost:5000/api" // backend local sans /api 
        : "/api"; // backend prod avec /api

    //  Charger la liste au démarrage
    useEffect(() => {
        const fetchChoices = async () => {
            try {
                // const response = await fetch("/choices");
                const response = await fetch(`${API_URL}/choices`);
                if (!response.ok) {
                    console.error("Erreur lors du chargement des choix");
                    return;
                }
                const data = await response.json();
                const existing = data.find(item => item.email === email);


                setSong1(existing.song1Id.replace("deezer_", ""));
                setSong2(existing.song2Id.replace("deezer_", ""));

                setChoice(existing);

            } catch (error) {
                //   setError("Impossible de récupérer la liste (serveur indisponible).");
            }
        };
        fetchChoices();
        // fetch("/api/choices")
        //   .then((res) => res.json())
        //   .then((data) => setChoicesList(data));


        const fetchActivity = async () => {
            try {
                // const response = await fetch("/choices");
                const response = await fetch(`${API_URL}/activities?email=${email}`);
                if (!response.ok) {
                    console.error("Erreur lors du chargement des choix");
                    return;
                }
                const data = await response.json();

                setActivity(data);

            } catch (error) {
                //   setError("Impossible de récupérer la liste (serveur indisponible).");
            }
        };
        fetchActivity();
    }, [API_URL, email]);

    // const [track1, setTrack1] = useState(null);
    // const [track2, setTrack2] = useState(null);

    //  useEffect(() => {
    //      fetch(`https://api.deezer.com/track/${song1}`)
    //          .then(res => res.json())
    //          .then(data => setTrack1(data));
    //  }, [song1]);

    //  useEffect(() => {
    //      fetch(`https://api.deezer.com/track/${song2}`)
    //          .then(res => res.json())
    //          .then(data => setTrack2(data));
    //  }, [song2]);

    return (
        <div>
            <h1>Contribution</h1>


            {choice ?
                <>
                    <p>Récapitulatif de vos contributions proposées :</p>
                    <div className="list-container">

                        <p><strong>{choice.name}</strong> a confirmé pour <strong>{choice.adultes}</strong> adultes et <strong>{choice.enfants}</strong> enfants.</p>
                        <p>Ils apporteront <strong>leur viande</strong> pour le barbecue</p>
                        <p>Il/elle apportera de quoi <strong>{choice.choice}</strong> : <strong>{choice.details}</strong></p>
                        {/* <p>{choice.email}</p> */}
                    </div>

                    {choice.services &&

                        <div>
                            <p>Il/elle s'est proposé d'aider pour les tâches suivantes : </p>
                            <ul>
                                {choice.services.map((service, index) => (
                                    <li key={service}>{service}</li>
                                ))}
                            </ul>
                        </div>
                    }

                    {choice.song1Id && choice.song2Id && (
                        <div>
                            <p>Il/elle a sélectionné les deux chansons suivantes :</p>
                            {/* <p>{choice.song1Id}</p> */}

{/* https://widget.deezer.com/widget/light/trackdeezer_2838140$ */}
                            <iframe
                                title="deezer-player"
                                src={`https://widget.deezer.com/widget/light/track/${song1}`}
                                width="300px"
                                height="190"
                                frameBorder="0"
                                allow="encrypted-media; clipboard-write"
                            ></iframe>
                            {/* <p>{choice.song2Id}</p> */}
{/* 
                            {track1 && (
                                <div className="deezer-track">
                                    <img src={track1.album.cover_medium} alt={track1.title} />
                                    <p><strong>{track1.title}</strong> – {track1.artist.name}</p>
                                    <audio controls src={track1.preview}></audio>
                                </div>
                            )}
                            {track2 && (
                                <div className="deezer-track">
                                    <img src={track2.album.cover_medium} alt={track2.title} />
                                    <p><strong>{track2.title}</strong> – {track2.artist.name}</p>
                                    <audio controls src={track2.preview}></audio>
                                </div>
                            )} */}
                            <iframe
                                title="deezer-player"
                                src={`https://widget.deezer.com/widget/light/track/${song2}`}
                                width="300px"
                                height="190"
                                frameBorder="0"
                                allow="encrypted-media; clipboard-write"
                            ></iframe>

                        </div>



                    )}


                    {activity && (
                        <div>
                            <p>Il/elle a proposé l'activité suivante : <strong>{activity.activity}</strong> d'une durée maximale de <strong>{activity.activityDuration}</strong>.</p>
                        </div>

                    )}

                    <p>
                        Dernière mise à jour le <strong>{new Date(choice.date).toLocaleString("fr-FR", {
                            day: "2-digit",
                            month: "2-digit",
                            year: "numeric",
                            hour: "2-digit",
                            minute: "2-digit"
                        })}</strong>
                    </p>
                </>
                :
                <div className="invite-warning">
                    <p>
                        Pour choisir vos morceaux, merci de d’abord compléter votre invitation.
                    </p>
                    <a href="/invitation" className="btn btn-validate">
                        Aller à la page Invitation
                    </a>
                </div>
            }
        </div>
    );
}

